module.exports = __webpack_public_path__ + "media/components/web/pages/sessions/resources/images/right_background-4d3aeb650fa35f893c44ccf40d3ce957.jpg";